import React from 'react';
import { TButtonOption, TRowOption, TSelectorRegularOption } from '../../../types/options';
import { Visual } from '../../Image/Visual';

type TSelectorRegularLeftIcon = {} & Pick<TButtonOption, 'iconName' | 'iconHierarchy' | 'iconVariant'> &
    Pick<TRowOption, 'avatar' | 'flagIcon'> &
    Pick<TSelectorRegularOption, 'isDisabled' | 'variant'>;

export const SelectorRegularLeftIcon = ({ iconName, iconVariant, iconHierarchy, avatar, flagIcon, variant, isDisabled }: TSelectorRegularLeftIcon) => {
    if (variant) {
        return false;
    }
    if (iconName) {
        return (
            <Visual
                isWidget={false}
                iconName={iconName}
                rightMargin
                iconHierarchy={iconHierarchy}
                iconVariant={iconVariant}
                size={'small'}
                isDisabled={isDisabled}
            />
        );
    }
    if (avatar) {
        return <Visual isWidget={false} rightMargin avatar={avatar} size={'small'} isDisabled={isDisabled} />;
    }
    if (flagIcon) {
        return <Visual isWidget={false} rightMargin flagIcon={flagIcon} size={'small'} isDisabled={isDisabled} />;
    }
    return false;
};
